import { createContext, ReactNode, useContext } from 'react';
import type { SchemaFormSize, SchemaFormVariant } from './schemaForm.types';

/**
 * Minimal render context for field components: how to render and where
 * their value lives in the form.
 */
export type FieldMode = 'display' | 'edit';

export type FieldContextValue = {
  mode: FieldMode;
  variant: SchemaFormVariant;
  size: SchemaFormSize;
  /** Base RHF path for fields rendered inside this context ('' at unit root). */
  basePath: string;
  /** Ghost rows (not yet persisted) get a distinct background. */
  ghost: boolean;
};

const FieldContext = createContext<FieldContextValue>({
  mode: 'display',
  variant: 'regular',
  size: 'md',
  basePath: '',
  ghost: false
});

export function FieldContextProvider({
  value,
  children
}: {
  value: FieldContextValue;
  children: ReactNode;
}) {
  return (
    <FieldContext.Provider value={value}>{children}</FieldContext.Provider>
  );
}

export function useFieldContext(): FieldContextValue {
  return useContext(FieldContext);
}
